import type { ReactNode } from 'react'

interface Props {
  title: string
  subtitle?: string
  children?: ReactNode
}

/** Cabeçalho das telas auxiliares do Modo Guia. */
export function GuiaPageHeader({ title, subtitle, children }: Props) {
  return (
    <header className='cf3-guia-section-hero'>
      <div className='cf3-guia-section-hero__main'>
        <h1 className='cf3-guia-section-hero__title'>{title}</h1>
        {subtitle && <p className='cf3-guia-section-hero__sub'>{subtitle}</p>}
      </div>
      {children && <div className='cf3-section-hero__actions'>{children}</div>}
    </header>
  )
}
